<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        رزرو اتاق جلسه
      </h4>
    </b-card-header>
    <b-card-body>
      <validation-observer
          #default="handleSubmit"
          ref="refFormObserver"
      >
        <b-form @submit.prevent>
          <b-row>
            <b-col md="4">
              <b-form-group
                  label="اتاق جلسه"
              >
                <b-overlay
                    :show="roomList.length === 0"
                >
                  <v-select
                      v-model="room_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="roomList"
                      :reduce="room => room.id"
                      title="فرقی نمی کند"
                  />
                </b-overlay>
              </b-form-group>
            </b-col>
            <b-col md="8">
              <b-form-group v-if="selectedRoom && selectedRoom.description"
                            label="توجه:"><p v-html="selectedRoom.description" class="text-warning"></p>
              </b-form-group>
            </b-col>


          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group
                  label="از تاریخ"
                  label-for="startat"
              >
                <date-picker
                    v-model="start_at"
                    type="datetime"
                    display-format="jDD jMMMM jYYYY HH:mm"
                    format="YYYY-MM-DD HH:mm"
                    :max="end_at"
                    clearable
                />

              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                  label="تا تاریخ"
                  label-for="end_at"
              >
                <date-picker
                    v-model="end_at"
                    type="datetime"
                    display-format="jDD jMMMM jYYYY HH:mm"
                    format="YYYY-MM-DD HH:mm"
                    :min="start_at"
                    clearable
                />

              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                  label="توضیحات"
              >
                <div>
                  <quill-editor
                      v-model="description"
                      :options="editorOption"
                  />
                </div>

              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <button
          class="btn btn-info mt-2"
          @click="createRoom"
      >
        ذخیره رزرو اتاق جلسه
      </button>
    </b-card-body>
  </b-card>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend, BFormInvalidFeedback, BFormCheckbox, BCardText,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import {quillEditor} from 'vue-quill-editor'
import {ValidationProvider, ValidationObserver, localize} from 'vee-validate'
import farsi from 'vee-validate/dist/locale/fa'
import formValidation from '@core/comp-functions/forms/form-validation'
import {required} from '@core/utils/validations/validations'

export default {
  name: 'RoomCreate',
  components: {
    BCardText,
    BFormCheckbox,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    VSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    quillEditor,
  },
  data() {
    return {
      room_id: null,
      start_at: null,
      end_at: null,
      description: null,
      roomList: [],
      editorOption: {
        theme: 'snow',
        placeholder: 'متن پیام را وارد کنید',
      },
      selectedRoom: null
    }
  },
  created() {
    localize('fa', {
      messages: farsi.messages,
    })
  },
  mounted() {
    this.getRooms()
  },
  methods: {

    createRoom() {
      this.$refs.refFormObserver.validate()
          .then(success => {
            if (success) {
              this.$http.post('room-reservations', {
                room_id: this.room_id,
                start_at: this.start_at,
                end_at: this.end_at,
                description: this.description
              })
                  .then(({data}) => {
                    if (data.status) {
                      this.room_id = null
                      this.start_at = null
                      this.end_at = null
                      this.description = null
                      this.$swal({
                        title: 'ثبت درخواست',
                        text: 'درخواست با موفقیت ثبت شد، منتظر تأیید مدیر بمانید',
                        icon: 'success',
                        confirmButtonText: 'متوجه شدم',
                        timer: 2000,
                      })


                    } else {
                      this.$bvToast.toast(data.message ?? 'در رزرو اتاق جلسه خطایی رخ داده', {
                        title: 'حطا',
                        toaster: 'b-toaster-top-right',
                        variant: 'danger',
                      })
                    }
                  })
                  .catch(error => {
                    this.$bvToast.toast(error.response.data.message ?? error.message, {
                      title: 'خطا در دریافت اطلاعات',
                      toaster: 'b-toaster-top-right',
                      variant: 'danger',
                    })
                  })
            }
          })
    },
    getRooms() {
      this.$http.get('rooms/for-select')
          .then(({data}) => {
            this.roomList = data
            this.roomList.unshift({
              'id' : 0,
              'name' : 'فرقی نمی کند',
              'description' : 'مسئول اتاق جلسات با توجه به شرایط اتاق جلسات تصمیم گیری می نماید. '
            })
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
  },
  watch: {
    'room_id': function (newVal, oldVal) {
      if (newVal === null) {
        this.selectedRoom = null
      } else {
        this.selectedRoom = this.roomList.find(room => room.id === newVal)
      }
    },
  },
  setup() {
    const {
      getValidationState,

    } = formValidation(name)

    return {
      getValidationState,
    }
  },
}
</script>

<style>

</style>
